export class Address {
  id?: number;
  zipCode?: number;
  street?: string;
  extNumber?: number;
  intNumber?: number;
  neighborhood?: string;
  latitude?: number;
  longitude?: number;
  state?: string;
  country?: string;
  city?: string;
}
